<template>
  <b-card
    class="mb-2"
  >
    <template #header>
      <div
        v-if="isLoading"
        class="pt-25"
      >
        <h5
          class="mb-1 mb-md-0 mr-0"
          style="width:200px"
        >
          <b-skeleton />
        </h5>
      </div>
      <div
        v-else
        :class="subtitle !== '' ? '' : 'card-header__content-wrapper'"
      >
        <h5 class="mb-1 mb-md-0 mr-0">
          {{ title }}
        </h5>
        <span
          v-if="subtitle !== ''"
          class="text-secondary text-sm w-100"
        >({{ subtitle }})</span>
        <span
          v-if="icon"
          class="ml-50 card-header__content-info-icon"
        >
          <GjIcon
            v-b-tooltip.hover="$tk(icon)"
            name="Info"
          />
        </span>
      </div>
    </template>
    <div v-if="isLoading && title !== 'PrebidAdapters' ">
      <b-row>
        <b-col
          v-for="index in 3"
          :key="index"
          sm="3"
        >
          <h5 class="font-weight-bolder">
            <b-skeleton width="60%" />
          </h5>
        </b-col>
      </b-row>
    </div>
    <slot
      v-else
      name="header"
    />
    <b-col
      md="12"
      :class="chartType !== 'pie' ? '' : 'd-flex justify-content-center'"
    >
      <loader
        v-if="isLoading"
        class="d-inline-block ml-50 position-loader"
        :size="24"
        :show="true"
      />
      <apexcharts
        :height="chartType !== 'pie' ? 200 : 240"
        :type="chartType"
        :series="(isLoading && chartData.series) ? [] : chartData.series"
        :options="chartType !== 'pie' ? chartOptions : pieChartOptions"
      />
    </b-col>
  </b-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { computed } from '@vue/composition-api'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import loader from '@/components/Loader.vue'

export default {
  components: {
    apexcharts: VueApexCharts,
    GjIcon,
    loader,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    chartData: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    wrapper: {
      type: Object,
    },
    isLoading: {
      type: [Boolean],
    },
    // eslint-disable-next-line vue/require-default-prop
    title: {
      type: [String],
    },
    subtitle: {
      type: [String],
      default: '',
    },
    icon: {
      type: [String],
      default: '',
    },
    colors: {
      type: [Array],
      default() {
        return ['#1e88e5', '#d4754d']
      },
    },
    chartType: {
      type: [String],
      default: 'line',
    },
  },
  setup(props) {
    const chartOptions = computed(() => ({
      chart: {
        shadow: {
          enabled: true,
          color: '#000',
          top: 18,
          left: 7,
          blur: 10,
          opacity: 1,
        },
        toolbar: {
          show: false,
        },
      },
      colors: props.colors,
      dataLabels: {
        enabled: true,
        formatter(val) {
          return val.toLocaleString()
        },
      },
      stroke: {
        curve: 'smooth',
      },
      grid: {
        borderColor: '#e7e7e7',
        row: {
          colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
        padding: {
          left: 30,
          right: 0,
        },
      },
      markers: {
        size: 5,
      },
      legend: {
        show: false,
      },
      xaxis: {
        categories: props.chartData.xAxisLabels,
      },
      yaxis: {
        decimalsInFloat: 2,
        labels: {
          formatter(value) {
            return value.toLocaleString()
          },
          offsetX: -10,
          align: 'left',
        },
      },
      tooltip: {
        x: {
          formatter(index) {
            if (props.wrapper.filter.compare) {
              return props.wrapper.firstChartFilterLabelName
            }
            return props.chartData.xAxisLabels[index - 1]
          },
        },
        y: {
          title: {
            formatter(seriesName, { dataPointIndex }) {
              if (props.wrapper.filter.compare) {
                if (seriesName === '1st') {
                  return props.chartData.series[0].tooltips[dataPointIndex].label
                }
                return props.chartData.series[1].tooltips[dataPointIndex].label
              }
              return seriesName
            },
          },
          formatter(value, { seriesIndex, dataPointIndex }) {
            return props.chartData.series[seriesIndex].tooltips[dataPointIndex].value
          },
        },
        z: {
          title: 'Title',
        },
      },
    }))
    const pieChartOptions = computed(() => ({
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: props.chartData.labels,
      yaxis: {
        decimalsInFloat: 2,
        labels: {
          formatter(value) {
            return value.toLocaleString()
          },
        },
      },
      legend: {
        position: 'right',
        horizontalAlign: 'center',
        showForSingleSeries: true,
      },
      colors: props.colors,
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
        },
      }],
    }))

    return {
      chartOptions,
      pieChartOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.card-header{
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  &__content-wrapper{
    display: inherit;
  }
  &__content-info-icon{
    padding-top: 3px;
  }
}
.position-loader{
  position: absolute;
  width: 96%;
  top: 40%;
  z-index: 1;
}
</style>
